import { useState } from "react";
import { BASE_URL } from "../api";
import useMount from "./useMount";

export type TaskStatus = "success" | "pending" | "failed" | "active";

export default function useProgress(streamKey: string){
    const [hlsProgress, setHlsProgress] = useState(0);
    const [mp4Progress, setMp4Progress] = useState(0);
    const [hlsStatus, setHlsStatus] = useState<TaskStatus>("pending");
    const [mp4Status, setMp4Status] = useState<TaskStatus>("pending");

  useMount(() => {
    if (!streamKey) return;
    const es = new EventSource(BASE_URL + `videos/progress/${streamKey}/stream`);
    es.addEventListener("connected", (e) => {
      console.log("SSE connected", e)
      console.log("SSE connected", JSON.parse(e.data));
    });

    es.addEventListener("progress", (e) => {
      console.log("progress update", e.data)
      const { hls, ['360p878kbs']: mp4 } = JSON.parse(e.data);
      setHlsProgress(hls);
      setMp4Progress(mp4);
    });

    es.addEventListener("status", (e) => {
      console.log("status update", e.data)

      const { hls, ['360p878kbs']: mp4 } = JSON.parse(e.data);

      // Map backend status to TaskStatus
      const mapStatus = (status: string): TaskStatus => {
        if (status === 'rendered') return 'success';
        if (status === 'rendering' || status === 'processing') return 'active';
        if (status === 'failed' || status === 'error') return 'failed';
        return 'pending';
      };

      if (hls !== undefined) {
        setHlsStatus(mapStatus(hls));
        if (hls === 'rendered') {
          setHlsProgress(100);
        }
      }
      if (mp4 !== undefined) {
        setMp4Status(mapStatus(mp4));
        if (mp4 === 'rendered') {
          setMp4Progress(100);
        }
      }
    });
    es.addEventListener("timeout", (e) => {
      console.log("SSE timeout")
      es.close();
      console.log("timeout update", e.data)
    });
    es.addEventListener("error", (e) => {
      console.log("SSE error", e);
      es.close();
    });

    return () => {
      console.log("Closing SSE for streamKey", streamKey);
      es.close();
    }
  }, [streamKey])

  return { hlsProgress, mp4Progress, hlsStatus, mp4Status };
}